import React from 'react'
import { supabase } from '@/lib/supabase'

export function useInOutEnabled() {
  const [enabled, setEnabled] = React.useState<boolean | null>(null)

  React.useEffect(() => {
    let mounted = true

    ;(async () => {
      try {
        const { data, error } = await supabase.rpc('user_inout_enabled')
        if (!mounted) return
        if (error) {
          console.error('user_inout_enabled error', error)
          setEnabled(false)
          return
        }
        setEnabled(Boolean(data))
      } catch (e) {
        console.error('user_inout_enabled error', e)
        if (mounted) setEnabled(false)
      }
    })()

    return () => {
      mounted = false
    }
  }, [])

  return enabled
}

